/**
 * WordPress dependencies
 */
import { store } from '@wordpress/interactivity';

/**
 * Standings utilities
 */
import {
  fetchStandingsData,
  updateStandingsTable,
  clearStandingsTable,
  extractErrorMessage,
  tournamentUtils,
} from '../../utils/standings.js';

/**
 * Fetch standings data using utility functions
 * @param {string} tournamentCalendarId - The tournament calendar ID
 */
async function fetchStandings(tournamentCalendarId) {
  if (!tournamentCalendarId) {
    return;
  }

  state.loading = true;
  state.error = null;

  try {
    const data = await fetchStandingsData(tournamentCalendarId);

    if (data?.data?.standings && data.data.standings.length > 0) {
      state.standings = data.data.standings;
      state.hasStandings = true;
      state.showContent = true;
      state.showEmpty = false;

      // Update the table body using utility function
      updateStandingsTable(data.data.standings);
    } else {
      state.standings = [];
      state.hasStandings = false;
      state.showContent = false;
      state.showEmpty = true;
    }
  } catch (error) {
    state.error = extractErrorMessage(error);
    state.standings = [];
    state.hasStandings = false;
    state.showContent = false;
    state.showEmpty = true;
  } finally {
    state.loading = false;
  }
}

/**
 * Frontend interactivity for the Standings block
 */
const { state } = store('big-bite-stats-perform/standings', {
  state: {},

  actions: {
    /**
     * Handle competition selection change
     * @param {Event} event - The change event
     */
    onCompetitionChange: (event) => {
      const selectedId = event.target.value;

      state.tournamentCalendarId = selectedId;

      if (!selectedId) {
        state.competitionName = '';
        state.standings = [];
        state.hasStandings = false;
        state.showContent = false;
        state.showEmpty = false;
        state.error = null;
        // Clear table body using utility function
        clearStandingsTable();
        return;
      }

      // Find the selected tournament using utility function
      const selectedTournament = tournamentUtils.findById(state.tournaments, selectedId);
      state.competitionName = selectedTournament?.name || 'Unknown Competition';

      // Fetch standings for the selected competition
      fetchStandings(selectedId);
    },
  },

  callbacks: {
    /**
     * Initialize the block
     */
    init: () => {
      // Auto-load standings if we have a default tournament ID
      if (state.tournamentCalendarId && state.competitionName) {
        fetchStandings(state.tournamentCalendarId);
      }
    },
  },
});
